"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopModalGallery = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const swiper_1 = require("swiper");
const components_1 = require("../components");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const containerClassName = 'desktop-modal-gallery';
const galleryTopClassName = 'gallery-top';
const DesktopModalGallery = ({ galleryItems, selectedIndex, isMediaGallery, }) => {
    (0, app_1.useDidMount)(() => {
        const couldHaveThumbnails = galleryItems && galleryItems.length > 1;
        let swiperGalleryThumbnails;
        if (couldHaveThumbnails) {
            swiperGalleryThumbnails = new swiper_1.default(`.${containerClassName} .gallery-thumbs`, {
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                spaceBetween: 15,
            });
        }
        try {
            new swiper_1.default(`.${containerClassName} .${galleryTopClassName}`, {
                allowTouchMove: false,
                initialSlide: selectedIndex,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                keyboard: {
                    enabled: true,
                },
                preventClicksPropagation: true,
                thumbs: {
                    swiper: swiperGalleryThumbnails,
                    slideThumbActiveClass: 'group swiper-slide-active',
                },
                observer: true,
                observeParents: true,
            });
        }
        catch (e) {
            console.error(e);
        }
    });
    const shouldHaveThumbnails = React.useMemo(() => galleryItems && galleryItems.length > 1, [galleryItems]);
    const galleryTopClasses = React.useMemo(() => `swiper-container group-[.desktop-modal-gallery]:w-full group-[.desktop-modal-gallery]:h-full ${galleryTopClassName} ${!shouldHaveThumbnails ? 'gallery-without-thumbs' : ''} gap-2xl flex flex-col touch-pan-y overflow-hidden`, [shouldHaveThumbnails]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: `${containerClassName} group gap-2xl flex flex-row relative items-center w-full`, children: [isMediaGallery ? ((0, jsx_runtime_1.jsx)("button", { className: `group swiper-button-prev ${shouldHaveThumbnails ? '' : 'opacity-0'}`, "aria-label": "Previous slide", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "chevron-left-outline", className: "bg-fill-primary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed p-2xs border-sm border-primary rounded-2xl hover:cursor-pointer group-[.swiper-button-disabled]:fill-icon-disabled group-[.swiper-button-disabled]:border-disabled group-[.swiper-button-disabled]:pointer-events-none" }) })) : null, (0, jsx_runtime_1.jsx)("div", { className: galleryTopClasses, children: (0, jsx_runtime_1.jsx)("div", { className: "swiper-wrapper group-[.desktop-modal-gallery]:items-center group-[.desktop-modal-gallery]:text-center box-content flex h-full relative transition-transform w-full z-1", children: galleryItems.map((item, index) => ((0, jsx_runtime_1.jsx)(components_1.GallerySlideWithVideoPlayer, { galleryItem: item, itemKey: index, isInModal: true, isMediaGallery: isMediaGallery }, index))) }) }), isMediaGallery ? ((0, jsx_runtime_1.jsx)("button", { className: `group swiper-button-next ${shouldHaveThumbnails ? '' : 'opacity-0'}`, "aria-label": "Next slide", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "chevron-right-outline", className: "bg-fill-primary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed p-2xs border-sm border-primary rounded-2xl hover:cursor-pointer group-[.swiper-button-disabled]:fill-icon-disabled group-[.swiper-button-disabled]:border-disabled group-[.swiper-button-disabled]:pointer-events-none" }) })) : null] }), shouldHaveThumbnails ? ((0, jsx_runtime_1.jsx)(components_1.GalleryThumbnails, { galleryItems: galleryItems, isInModal: true })) : ('')] }));
};
exports.DesktopModalGallery = DesktopModalGallery;
exports.default = exports.DesktopModalGallery;
